import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faAngleRight,
  faSignOutAlt,
  faTimes,
  faUsers,
  faChevronCircleDown,
  faListAlt,
  faUserCircle
} from '@fortawesome/free-solid-svg-icons'

// ARMLib dependencies
import BootstrapVue from 'bootstrap-vue'
import Vuelidate from 'vuelidate'
import ToggleButton from 'vue-js-toggle-button'
Vue.use(BootstrapVue)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(Vuelidate)
Vue.use(ToggleButton)

//ARMLib
import ARMLib from 'arm-vue-lib'
import 'arm-vue-lib/dist/arm-vue-lib.css'
Vue.use(ARMLib)

// Import mixins
import FormTypes from '@/mixins/form_types'

Vue.config.productionTip = false

library.add(
  faUsers,
  faChevronCircleDown,
  faListAlt,
  faUserCircle,
  faSignOutAlt,
  faTimes,
  faAngleRight
)

String.prototype.interpolate = function(params) {
  const names = Object.keys(params)
  const vals = Object.values(params)
  return new Function(...names, `return \`${this}\`;`)(...vals)
}

router.beforeEach((to, from, next) => {
  const afterLogin = () => {
    if (
      ['Unauthorized', 'fcSubscriptions'].indexOf(to.name) > -1 ||
      /base_role=postgraphile_infrastructure/.test(store.state.role)
    ) {
      next()
    } else {
      next({ name: 'Unauthorized' })
    }
  }
  const checkLogin = () => {
    if (store.state.checkingLogin) {
      setTimeout(checkLogin, 10)
    } else {
      afterLogin()
    }
  }
  store.commit('getLogin')
  setTimeout(checkLogin, 10)
})

Vue.mixin(ARMLib._mixins.FormActions)
Vue.mixin(ARMLib._mixins.HashActions)
Vue.mixin(ARMLib._mixins.Common)
Vue.mixin(FormTypes)

Vue.mixin({
  data: function() {
    return {
      emailRobotList: process.env.VUE_APP_EMAIL_ROBOT_LIST
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
